import React from "react";
import BannerBG from "../../../assets/careers-banner-bg.png";
import BannerIMG from "../../../assets/careers-banner-image.png";

function CareersBannerSection({ careers_banner }) {
  const defaultTitle = "Be a Part of the Laguna Creek Team";
  const defaultContent =
    "<p>Laguna Creek is always on the lookout for talented engineers to join our team and help fulfill our mission of boosting the Indigenous tourism economy</p><p>We offer competitive salaries and benefits, with a great working environment, and an opportunity to grow along with the company. Native preference, but any innovative, experienced applicants are encouraged to apply.</p>";
  const defaultBannerIMG = BannerIMG;

  const title = careers_banner?.banner_title || defaultTitle;
  const content = careers_banner?.banner_text || defaultContent;
  const image = careers_banner?.banner_img || defaultBannerIMG;

  const container = document.createElement("div");
  container.innerHTML = content;

  const paragraphs = Array.from(container.querySelectorAll("p"));

  paragraphs.forEach((p, index) => {
    p.className =
      "text-lg font-light leading-7 text-[#333333] " +
      (index === paragraphs.length - 1 ? "mb-8" : "mb-3");
  });

  return (
    <section
      className="py-11"
      style={{
        backgroundImage: `url(${BannerBG})`,
      }}
    >
      <div className="w-full max-w-[1570px] px-4 mx-auto">
        <div className="flex flex-wrap items-center -mx-4">
          <div className="w-full lg:w-1/2 max-w-full px-4 text-center lg:text-left">
            <h3 className="text-[30px] md:text-[40px] lg:text-[52px] font-normal leading-tight text-[#5fa3b2] mb-4">
              {title}
            </h3>
            <div dangerouslySetInnerHTML={{ __html: container.innerHTML }} />
          </div>
          <div className="w-full lg:w-1/2 max-w-full px-4">
            <img
              src={image}
              alt="OurStory"
              className="mr-auto lg:mr-0 ml-auto"
              height="841"
              width="663"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default CareersBannerSection;
